import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DvSettingsMenuItem, DvSettingsMenuModule } from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [DvSettingsMenuModule, CommonModule, RouterModule, TranslateModule],
  selector: 'app-settings-group-page',
  templateUrl: './settings-group-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./settings-group-page.component.scss'],
})
export class SettingsGroupPageComponent {
  @Input() icon: string;
  @Input() settingsMenuPageTitle: string;
  @Input() settingsMenuPageItems: DvSettingsMenuItem[];
}
